import React, { useMemo, useEffect } from 'react';
import cn from 'classnames';
import SearchInput from 'components/search/SearchInput';
import PopularSearches from 'components/search/PopularSearches';
import MobileSearchSuggestions from './MobileSearchSuggestions';
import { useSearch } from 'utils/search';
import { useHistoryCallback } from 'utils/routing';
import { pushSearchEvent } from 'utils/analytics';
import { observer, searchStore as store } from 'store';

import * as styles from './MobileSearch.module.scss';

function MobileSearch({
  className,
  searchActive,
  setSearchActive,
  setActiveMobileMenu,
  mobileMenuOpen,
}) {
  const {
    search,
    showList,
    handleSearch,
    handleKeyDown,
    handleItemClick,
    clearSearch,
    suggestions,
  } = useSearch({ insideMenu: true });
  const showSuggestions = showList && suggestions.length > 0;

  const preparedStyle = useMemo(() => {
    const style = {
      '--left': store.mobileSearchCoordinates.left,
      '--right': store.mobileSearchCoordinates.right,
    };

    return style;
  }, [store.mobileSearchCoordinates]);

  const handleSearchActive = () => {
    setSearchActive(true);
    pushSearchEvent({
      action: 'search_open',
      deviceType: 'Mobile',
      pageUrl: window.location.href,
    });
  };

  const preparedHandleItemClick = value => {
    handleItemClick(value);
    setActiveMobileMenu(false);
  };

  const preparedHandleKeyDown = e => {
    if (search.length > 0 && e.key === 'Enter') {
      handleKeyDown(e);
      setActiveMobileMenu(false);
    }
  };

  useEffect(() => {
    if (!searchActive) {
      clearSearch();
    }
  }, [searchActive]);

  useEffect(() => {
    if (searchActive && !mobileMenuOpen) {
      pushSearchEvent({
        action: 'click_on_close_button',
        deviceType: 'Mobile',
        pageUrl: window.location.href,
      });
    }
  }, [mobileMenuOpen, searchActive]);

  useHistoryCallback(clearSearch);

  return (
    <div
      className={cn(styles.mobileSearch, searchActive && styles.searchActive, className)}
      style={preparedStyle}
    >
      <SearchInput
        className={styles.searchInput}
        search={search}
        showList={false}
        results={suggestions}
        clearSearch={clearSearch}
        handleSearch={handleSearch}
        handleKeyDown={preparedHandleKeyDown}
        onInputClick={handleSearchActive}
      />
      <div className={styles.searchContent}>
        <PopularSearches
          className={styles.popular}
          handleTagClick={preparedHandleItemClick}
          theme="mobile"
        />
        <MobileSearchSuggestions
          className={cn(styles.suggestions, showSuggestions && styles.visible)}
          showSuggestions={showSuggestions}
          suggestions={suggestions}
          handleItemClick={preparedHandleItemClick}
        />
      </div>
    </div>
  );
}

export default observer(MobileSearch);
